export default [
    {
        path: '/event-invitations',
        name: 'event-invitation',
        meta: { requiresAuth: true },
        component: () => import('@/pages/event-invitation/index.vue')
    }
]
